// react
import styled, { css } from 'styled-components';

// @transform-path ../../../../../../src/assets/corporate-memphis/happy-family1.png
import happyFamily1 from '@/assets/corporate-memphis/happy-family1.png';
// @transform-path ../../../../../../src/assets/corporate-memphis/elderly-couple1.png
import elderlyCouple1 from '@/assets/corporate-memphis/elderly-couple1.png';
// @transform-path ../../../../../../src/assets/corporate-memphis/elderly-couple2.png
import elderlyCouple2 from '@/assets/corporate-memphis/elderly-couple2.png';
// @transform-path ../../../../../../src/assets/corporate-memphis/kindness1.png
import kindness1 from '@/assets/corporate-memphis/kindness1.png';
// @transform-path ../../../../../../src/assets/corporate-memphis/planning.png
import planning from '@/assets/corporate-memphis/planning.png';
// @transform-path ../../../../../../src/assets/corporate-memphis/starting.png
import starting from '@/assets/corporate-memphis/starting.png';
// @transform-path ../../../../../../src/assets/corporate-memphis/regular.png
import regular from '@/assets/corporate-memphis/regular.png';
// @transform-path ../../../../../../src/assets/corporate-memphis/end-of-life.png
import endOfLife from '@/assets/corporate-memphis/end-of-life.png';

export type MemphisSize = 'sm' | 'md' | 'lg';
export type MemphisVariant =
  | 'happy-family-1'
  | 'elderly-couple-1'
  | 'elderly-couple-2'
  | 'kindness-1'
  | 'planning'
  | 'starting'
  | 'regular'
  | 'end-of-life';

const images: { [key in MemphisVariant]: any } = {
  'happy-family-1': happyFamily1,
  'elderly-couple-1': elderlyCouple1,
  'elderly-couple-2': elderlyCouple2,
  'kindness-1': kindness1,
  planning: planning,
  starting: starting,
  regular: regular,
  'end-of-life': endOfLife,
};

export const Memphis = ({
  className,
  variant = 'happy-family-1',
  size = 'md',
}: MemphisProps) => {
  return (
    <Wrapper className={className} $size={size}>
      <Image src={images[variant]} alt='warm image' />
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $size: MemphisSize }>`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  overflow: hidden;

  ${(props) => {
    switch (props.$size) {
      case 'sm':
        return css`
          height: 100px;
        `;
      case 'md':
        return css`
          height: 250px;
        `;
      case 'lg':
        return css`
          height: 400px;
        `;
    }
  }}
`;

const Image = styled.img`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  object-fit: contain;
  max-height: 100%;
`;

interface MemphisProps {
  className?: string;
  variant?: MemphisVariant;
  size?: MemphisSize;
}

Memphis.displayName = 'Memphis';

export default Memphis;
